{
  "clipBoard": {
    "copySuccess": "Copied successfully"
  }
}
